/* eslint-disable import/prefer-default-export */
export const SALES_CONDITIONS = [
  { label: 'Par unité', value: 'UNIT' },
  { label: 'Par jeu', value: 'GAME' },
  { label: 'Par pack', value: 'PQCK' },
];
